import { combineReducers } from '@reduxjs/toolkit';

import { defectsSlice } from './defectsSlice';
import { mediaEngineeringsSlice } from './mediaEngineeringsSlice';
import { engineeringInfoSlice } from './engineeringInfoSlice';
import { engineeringStatusSlice } from './engineeringStatusSlice';
import { networkCheckListSlice } from './engineeringChekListSlice';
import { callHistorySlice } from './callHistorySlice';
import { guaranteeLetterSlice } from './guaranteeLetterSlice';

export const engineeringStatus = combineReducers({
  defects: defectsSlice.reducer,
  mediaEngineerings: mediaEngineeringsSlice.reducer,
  callHistory: callHistorySlice.reducer,
  engineeringInfo: engineeringInfoSlice.reducer,
  guaranteeLetter: guaranteeLetterSlice.reducer,
  engineeringStatus: engineeringStatusSlice.reducer,
  networkCheckList: networkCheckListSlice.reducer,
});
